import { defineMessages } from 'react-intl';

export default defineMessages({
  additionalFieldsRequired: {
    id: 'github-auth-button.additional-fields-required',
    defaultMessage:
      'In order to complete your claim we need a few more details in order to sign up',
  },
});



// WEBPACK FOOTER //
// ./src/ui/graphql/GithubAuthButton/messages.js